import { createSelector } from "reselect";
import getProfessionSelector from "./getProfessionSelector";

export default createSelector(getProfessionSelector, (profession: Profession) => profession.ID);
